import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const Terms = () => {
  return (
    <section className="min-h-screen bg-[#0A0E14] pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm">Back to Home</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Terms and Conditions</h1>
        <p className="text-gray-400 mb-12">Last updated: January 2025</p>

        <div className="glass-card rounded-2xl p-8 md:p-12 space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="leading-relaxed">
              By accessing and using MBhost services, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, please do not use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Service Description</h2>
            <p className="leading-relaxed">
              MBhost provides cloud infrastructure services including compute, storage, databases, and related services. We reserve the right to modify, suspend, or discontinue any part of our services at any time.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Account Registration</h2>
            <p className="leading-relaxed mb-4">
              To use our services, you must:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Provide accurate and complete registration information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Be at least 18 years of age</li>
              <li>Comply with all applicable laws and regulations</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Acceptable Use Policy</h2>
            <p className="leading-relaxed mb-4">
              You agree not to use MBhost services to:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Distribute malware, spam, or harmful content</li>
              <li>Engage in unauthorized access or security breaches</li>
              <li>Interfere with the proper functioning of our services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Payment Terms</h2>
            <p className="leading-relaxed">
              All fees are in Indian Rupees (INR) unless otherwise stated. Payment is due according to your selected billing cycle. We accept major credit cards, debit cards, and other payment methods as indicated on our platform.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Service Level Agreement (SLA)</h2>
            <p className="leading-relaxed">
              We guarantee 99.99% uptime for our services. If we fail to meet this commitment, you may be eligible for service credits as outlined in our SLA documentation.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">7. Data Protection</h2>
            <p className="leading-relaxed">
              You retain all rights to your data. We implement appropriate technical and organizational measures to protect your data. Our data protection practices are detailed in our Privacy Policy.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">8. Limitation of Liability</h2>
            <p className="leading-relaxed">
              MBhost shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use or inability to use our services.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">9. Termination</h2>
            <p className="leading-relaxed">
              We may terminate or suspend your account immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">10. Governing Law</h2>
            <p className="leading-relaxed">
              These Terms shall be governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Mumbai, India.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">11. Contact Information</h2>
            <p className="leading-relaxed">
              For questions about these Terms, contact us at:
              <br />
              <span className="text-green-400">legal@mbhost.in</span>
              <br />
              MBhost Cloud Pvt Ltd, A unit of MBT Ventures Ltd.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};